<template>
  <div class="box">
    <div class="nav">
      <div v-for="(item, index) in menus">
        <router-link tag="div" class="nav_text CU" :class="selectedkeys == item.meta.title ? 'nav_text_active' : ''" :to="item.path">
          {{ $t('router.' + [item.meta.title]) }}
        </router-link>
      </div>
    </div>
    <div class="account_management"><router-view></router-view></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedkeys: this.$route.meta.title
    };
  },
  created() {
  },
  methods: {},
  watch: {
    $route(to, from) {
      return (this.selectedkeys = to.meta.title);
    }
  },
  computed: {
    menus() {
      return this.$router.options.routes[0].children[0].children[4].children;
    }
  }
};
</script>

<style scoped="scoped">
.box {
  width: 1160px;
  background-color: #ffffff;
  box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  margin: 90px auto 0;
  display: flex;
  margin-bottom: 105px;
}
.nav {
  width: 165px;
  background-color: #f3f3f3;
}
.nav_text {
  width: 165px;
  height: 52px;
  text-align: center;
  line-height: 52px;
}
.nav_text_active {
  box-sizing: border-box;
  border-left: 4px solid #4990fa;
  background-color: #ffffff;
}
.account_management {
  width: 1004px;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/account_management.vue